import { render, staticRenderFns } from "./BeamerClubAssistant.vue?vue&type=template&id=3511120d&scoped=true&"
import script from "./BeamerClubAssistant.vue?vue&type=script&lang=js&"
export * from "./BeamerClubAssistant.vue?vue&type=script&lang=js&"
import style0 from "./BeamerClubAssistant.vue?vue&type=style&index=0&id=3511120d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3511120d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
